import React, { useState } from 'react';
import { Header } from '../components/Header';
import { CountryHero } from '../components/CountryHero';
import { CountryInfo } from '../components/CountryInfo';
import { TourFilters } from '../components/TourFilters';
import { TourGrid } from '../components/TourGrid';
import { RelatedDestinations } from '../components/RelatedDestinations';
import { Footer } from '../components/Footer';
interface CountryPageProps {
  onTourClick: (tourId: string) => void;
}
export function CountryPage({
  onTourClick
}: CountryPageProps) {
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOption, setSortOption] = useState('recommended');
  const [viewMode, setViewMode] = useState('grid');
  const [currentPage, setCurrentPage] = useState(1);
  const [filtersOpen, setFiltersOpen] = useState(false);
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-2310">
      <Header data-id="element-2311" />
      <main className="flex-grow" data-id="element-2312">
        <CountryHero data-id="element-2313" />
        <CountryInfo data-id="element-2314" />
        <section className="py-12 bg-white" id="explore-tours-section" data-id="element-2315">
          <div className="container mx-auto px-4" data-id="element-2316">
            <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-2317">
              Explore Switzerland Tours
            </h2>
            <TourFilters activeFilter={activeFilter} setActiveFilter={setActiveFilter} searchQuery={searchQuery} setSearchQuery={setSearchQuery} sortOption={sortOption} setSortOption={setSortOption} viewMode={viewMode} setViewMode={setViewMode} filtersOpen={filtersOpen} setFiltersOpen={setFiltersOpen} data-id="element-2318" />
            <TourGrid activeFilter={activeFilter} searchQuery={searchQuery} sortOption={sortOption} viewMode={viewMode} currentPage={currentPage} setCurrentPage={setCurrentPage} onTourClick={onTourClick} data-id="element-2319" />
          </div>
        </section>
        <RelatedDestinations data-id="element-2320" />
      </main>
      <Footer data-id="element-2321" />
    </div>;
}